import React from 'react';
import t from '~t';
import config from '~config';

import { Button, Icon } from '~ui';

export default function SettingsTfaHelp() {
  return (
    <Button asChild variant='ghost' size='icon'>
      <a href={config.links.help.tfa} target='_blank' title={t.s('howToUse')}>
        <Icon name='help' />
      </a>
    </Button>
  );
}
